import type { Mix } from '@/models/Mix'

export class MixNutritionService {
  constructor(private mix: Mix) {}

  calculate() {
    this.resetNutrients()
    let totalWeight = 0
    const { base, basePercent, nutrients, nonBaseItems } = this.mix

    for (const item of nonBaseItems) {
      totalWeight += item.ingredient.weight * item.amount
      nutrients.fats =
        nutrients.fats + this.nutritionPerPortion(item.ingredient.fats, item.ingredient.weight, item.amount)
      nutrients.saturatedFats =
        nutrients.saturatedFats +
        this.nutritionPerPortion(item.ingredient.saturatedFats, item.ingredient.weight, item.amount)
      nutrients.carbohydrates =
        nutrients.carbohydrates +
        this.nutritionPerPortion(item.ingredient.carbohydrates, item.ingredient.weight, item.amount)
      nutrients.sugars =
        nutrients.sugars + this.nutritionPerPortion(item.ingredient.sugars, item.ingredient.weight, item.amount)
      nutrients.fibre =
        nutrients.fibre + this.nutritionPerPortion(item.ingredient.fibre, item.ingredient.weight, item.amount)
      nutrients.proteins =
        nutrients.proteins + this.nutritionPerPortion(item.ingredient.proteins, item.ingredient.weight, item.amount)
      nutrients.salt =
        nutrients.salt + this.nutritionPerPortion(item.ingredient.salt, item.ingredient.weight, item.amount)
      nutrients.energy =
        nutrients.energy + this.nutritionPerPortion(item.ingredient.energy, item.ingredient.weight, item.amount)
    }

    if (base !== undefined) {
      const baseWeight = base.ingredient.weight * (basePercent / 100)
      totalWeight += baseWeight
      nutrients.fats = nutrients.fats + this.nutritionPerPortion(base.ingredient.fats, baseWeight, base.amount)
      nutrients.saturatedFats =
        nutrients.saturatedFats + this.nutritionPerPortion(base.ingredient.saturatedFats, baseWeight, base.amount)
      nutrients.carbohydrates =
        nutrients.carbohydrates + this.nutritionPerPortion(base.ingredient.carbohydrates, baseWeight, base.amount)
      nutrients.sugars = nutrients.sugars + this.nutritionPerPortion(base.ingredient.sugars, baseWeight, base.amount)
      nutrients.fibre = nutrients.fibre + this.nutritionPerPortion(base.ingredient.fibre, baseWeight, base.amount)
      nutrients.proteins =
        nutrients.proteins + this.nutritionPerPortion(base.ingredient.proteins, baseWeight, base.amount)
      nutrients.salt = nutrients.salt + this.nutritionPerPortion(base.ingredient.salt, baseWeight, base.amount)
      nutrients.energy = nutrients.energy + this.nutritionPerPortion(base.ingredient.energy, baseWeight, base.amount)
    }

    const energy = (nutrients.energy * 100) / totalWeight
    nutrients.fats = this.roundNutrition((nutrients.fats * 100) / totalWeight)
    nutrients.saturatedFats = this.roundNutrition((nutrients.saturatedFats * 100) / totalWeight)
    nutrients.carbohydrates = this.roundNutrition((nutrients.carbohydrates * 100) / totalWeight)
    nutrients.sugars = this.roundNutrition((nutrients.sugars * 100) / totalWeight)
    nutrients.fibre = this.roundNutrition((nutrients.fibre * 100) / totalWeight)
    nutrients.proteins = this.roundNutrition((nutrients.proteins * 100) / totalWeight)
    nutrients.salt = this.roundNutrition((nutrients.salt * 100) / totalWeight)
    nutrients.energy = this.roundNutrition(energy)
    nutrients.energyKcal = this.roundNutrition(energy / 4.185)
  }

  nutritionPerPortion = (nutrition: string, weight: number, quantity: number, portion = 100) => {
    return Number.parseFloat(nutrition) * ((quantity * weight) / portion)
  }

  roundNutrition = (nutrition: number) => {
    if (nutrition) {
      return Number(nutrition.toFixed(2))
    }

    return 0
  }

  resetNutrients() {
    this.mix.nutrients = {
      fats: 0,
      saturatedFats: 0,
      carbohydrates: 0,
      sugars: 0,
      fibre: 0,
      proteins: 0,
      salt: 0,
      energy: 0,
      energyKcal: 0,
    }
  }
}
